/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 11:06:20
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:32:34
 * @FilePath: \zhucai_user\src\api\member.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/util/request";

export function ForgotPassword(data) {
  return request({
    url: "/pc/Login/ForgotPassword",
    method: "post",
    data,
  });
}
export function GetUserInfo(params) {
  return request({
    url: "/pc/Member/GetUserInfo",
    method: "get",
    params,
  });
}
export function GetOrgns(params) {
  return request({
    url: "/pc/Member/GetOrgns",
    method: "get",
    params,
  });
}
export function SaveUserInfo(data) {
  return request({
    url: "/pc/Member/SaveUserInfo",
    method: "post",
    data,
  });
}
export function ApplyManager(data) {
  return request({
    url: "/pc/Member/ApplyManager",
    method: "post",
    data,
  });
}
export function ChangePassword(data) {
  return request({
    url: "/pc/Member/ChangePassword",
    method: "post",
    data,
  });
}
export function ChangePhone(data) {
  return request({
    url: "/pc/Member/ChangePhone",
    method: "post",
    data,
  });
}
export function GetMyCourseList(params) {
  return request({
    url: "/pc/Member/GetMyCourseList",
    method: "get",
    params,
  });
}
export function GetMyMaterialList(params) {
  return request({
    url: "/pc/Member/GetMyMaterialList",
    method: "get",
    params,
  });
}
export function GetMyExerList(params) {
  return request({
    url: "/pc/Member/GetMyExerList",
    method: "get",
    params,
  });
}
export function GetMyWrongList(params) {
  return request({
    url: "/pc/Member/GetMyWrongList",
    method: "get",
    params,
  });
}
export function Wrong_CreateCard(params) {
  return request({
    url: "/pc/Exam/Wrong_CreateCard",
    method: "get",
    params,
  });
}
export function Enroll_GetFileds(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetFileds",
    method: "get",
    params,
  });
}
export function Enroll_UserSubEnroll(data) {
  return request({
    url: "/pc/Enroll/Enroll_UserSubEnroll",
    method: "post",
    data,
  });
}
export function Enroll_UserCancelrEnroll(data) {
  return request({
    url: "/pc/Enroll/Enroll_UserCancelrEnroll",
    method: "post",
    data,
  });
}
export function GetMyEnrollList(params) {
  return request({
    url: "/pc/Member/GetMyEnrollList",
    method: "get",
    params,
  });
}
export function GetMyEnrollDetail(params) {
  return request({
    url: "/pc/Member/GetMyEnrollDetail",
    method: "get",
    params,
  });
}
export function GetMyCertList(params) {
  return request({
    url: "/pc/Member/GetMyCertList",
    method: "get",
    params,
  });
}
export function GetMyCertDetail(params) {
  return request({
    url: "/pc/Member/GetMyCertDetail",
    method: "get",
    params,
  });
}
export function MyCertFeekBack(data) {
  return request({
    url: "/pc/Member/MyCertFeekBack",
    method: "post",
    data,
  });
}
export function GetMyCertTargetList(params) {
  return request({
    url: "/pc/Member/GetMyCertTargetList",
    method: "get",
    params,
  });
}
export function GetMyCertTargetDetail(params) {
  return request({
    url: "/pc/Member/GetMyCertTargetDetail",
    method: "get",
    params,
  });
}
export function MyCertTargetEdit(data) {
  return request({
    url: "/pc/Member/MyCertTargetEdit",
    method: "post",
    data,
  });
}
export function MyCertTargetDel(data) {
  return request({
    url: "/pc/Member/MyCertTargetDel",
    method: "post",
    data,
  });
}
export function MyCertTargetHidden(data) {
  return request({
    url: "/pc/Member/MyCertTargetHidden",
    method: "post",
    data,
  });
}
// 证书分类名称
export function CertType_GetTreeList(params) {
  return request({
    url: "/pc/Common/CertType_GetTreeList",
    method: "get",
    params,
  });
}
// 证书类型列表
export function Classify_GetList(params) {
  return request({
    url: "/pc/Common/Classify_GetList",
    method: "get",
    params,
  });
}
//证书分类选择
export function CertType_GetList(params) {
  return request({
    url: "/pc/Common/CertType_GetList",
    method: "get",
    params,
  });
}

export function GetMyExamCertList(params) {
  return request({
    url: "/pc/Member/GetMyExamCertList",
    method: "get",
    params,
  });
}
export function GetMyOrdersList(params) {
  return request({
    url: "/pc/Member/GetMyOrdersList",
    method: "get",
    params,
  });
}
export function GetMyOrdersDetail(params) {
  return request({
    url: "/pc/Member/GetMyOrdersDetail",
    method: "get",
    params,
  });
}
export function MyOrdersCancel(data) {
  return request({
    url: "/pc/Member/MyOrdersCancel",
    method: "post",
    data,
  });
}

export function GetMyInvoiceList(params) {
  return request({
    url: "/pc/Member/GetMyInvoiceList",
    method: "get",
    params,
  });
}
export function GetMyInvoiceDetail(params) {
  return request({
    url: "/pc/Member/GetMyInvoiceDetail",
    method: "get",
    params,
  });
}
export function GetMyInvoiceSelectOrders(params) {
  return request({
    url: "/pc/Member/GetMyInvoiceSelectOrders",
    method: "get",
    params,
  });
}
export function MyInvoice_Apply(data) {
  return request({
    url: "/pc/Member/MyInvoice_Apply",
    method: "post",
    data,
  });
}
export function GetMyTaskList(params) {
  return request({
    url: "/pc/Member/GetMyTaskList",
    method: "get",
    params,
  });
}
export function GetMyTaskDetail(params) {
  return request({
    url: "/pc/Member/GetMyTaskDetail",
    method: "get",
    params,
  });
}
export function GetSalesFxTotalAmount(params) {
  return request({
    url: "/pc/Member/GetSalesFxTotalAmount",
    method: "get",
    params,
  });
}
export function GetSalesFxList(params) {
  return request({
    url: "/pc/Member/GetSalesFxList",
    method: "get",
    params,
  });
}
export function GetSalesFhTotalAmount(params) {
  return request({
    url: "/pc/Member/GetSalesFhTotalAmount",
    method: "get",
    params,
  });
}
export function GetSalesFhList(params) {
  return request({
    url: "/pc/Member/GetSalesFhList",
    method: "get",
    params,
  });
}
export function GetNoticeList(params) {
  return request({
    url: "/pc/Member/GetNoticeList",
    method: "get",
    params,
  });
}
export function GetNoticeDetail(params) {
  return request({
    url: "/pc/Member/GetNoticeDetail",
    method: "get",
    params,
  });
}

export function GetFeedBackList(params) {
  return request({
    url: "/pc/Member/GetFeedBackList",
    method: "get",
    params,
  });
}
export function GetFeedBackDetail(params) {
  return request({
    url: "/pc/Member/GetFeedBackDetail",
    method: "get",
    params,
  });
}
export function FeedBack(data) {
  return request({
    url: "/pc/Member/FeedBack",
    method: "post",
    data,
  });
}
export function OrgnManage_GetUserList(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetUserList",
    method: "get",
    params,
  });
}
export function OrgnManage_GetUserDetail(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetUserDetail",
    method: "get",
    params,
  });
}
export function OrgnManage_GetUserStudyList(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetUserStudyList",
    method: "get",
    params,
  });
}
export function OrgnManage_GetUserCertList(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetUserCertList",
    method: "get",
    params,
  });
}
export function OrgnManage_GetTaskList(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetTaskList",
    method: "get",
    params,
  });
}
export function OrgnManage_ApplyTask(data) {
  return request({
    url: "/pc/Member/OrgnManage_ApplyTask",
    method: "post",
    data,
  });
}
export function OrgnManage_GetTaskDetail(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetTaskDetail",
    method: "get",
    params,
  });
}
export function OrgnManage_GetTaskUserList(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetTaskUserList",
    method: "get",
    params,
  });
}
export function OrgnManage_GetTaskUserDetail(params) {
  return request({
    url: "/pc/Member/OrgnManage_GetTaskUserDetail",
    method: "get",
    params,
  });
}
export function OrgnManage_UserExport(params) {
  return request({
    url: "/pc/Member/OrgnManage_UserExport",
    method: "get",
    params,
  });
}
export function CheckSMS(data) {
  return request({
    url: "/pc/Member/CheckSMS",
    method: "post",
    data,
  });
}
export function GetMyFavCourseList(params) {
  return request({
    url: "/pc/Member/GetMyFavCourseList",
    method: "get",
    params,
  });
}
export function GetMyFavMaterialList(params) {
  return request({
    url: "/pc/Member/GetMyFavMaterialList",
    method: "get",
    params,
  });
}
export function GetMyFavExerList(params) {
  return request({
    url: "/pc/Member/GetMyFavExerList",
    method: "get",
    params,
  });
}
export function FavDel(data) {
  return request({
    url: "/pc/Member/FavDel",
    method: "post",
    data,
  });
}

export function GetUserBalance(params) {
  return request({
    url: "/pc/Member/GetUserBalance",
    method: "get",
    params,
  });
}
export function GetTxList(params) {
  return request({
    url: "/pc/Member/GetTxList",
    method: "get",
    params,
  });
}

export function TxRecord_Add(data) {
  return request({
    url: "/pc/Member/TxRecord_Add",
    method: "post",
    data,
  });
}
